/**
 * Модель для работы со структурными подразделениями
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import { IId, IDepartament, IUser, IShortUser } from '../models/types';

import UsersService, { IDepartmentBody } from '../services/UsersService';

interface IDataUsers {
  data: IUser[];
  pageIndex: number;
  total: number;
}

interface IData {
  users: IDataUsers;
  shortUsers: IShortUser[];
}

interface IList {
  data: IDepartament[] | null;
  pagesCount: number;
}

interface IState {
  data: IData;
  list: IDepartament[] | null;
  item: IDepartament | null;
}

const initialState: IState = {
  data: {
    users: {
      data: [],
      pageIndex: 0,
      total: 0
    },
    shortUsers: []
  },
  list: null,
  item: null
};

export const staffDepartaments = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: Partial<IData>): IState {
      return { ...state, data: { ...state.data, ...payload } };
    },
    setList(state: IState, payload: IDepartament[]): IState {
      return { ...state, list: payload };
    },
    setItem(state: IState, payload: IDepartament): IState {
      return { ...state, item: payload };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getData() {
      const { data: shortUsers } = await UsersService.getAllEmployeesShort();

      this.setData({ shortUsers });
    },
    async getDataUsers(params: any, rootState?: any) {
      const { users } = rootState.staffDepartaments.data;

      const {
        data: { employees: data, total, pageIndex: page }
      } = await UsersService.getAllEmployees(params);

      this.setData({
        users: { data: [...(params.pageIndex ? users.data : []), ...data], total, pageIndex: page }
      });
    },
    async getList(params: any, rootState?: any) {
      try {
        const { data } = await UsersService.getDepartmentsAll({ includeEmployees: true });

        this.setList(data);
      } catch (error) {
        return error;
      }
    },
    async getItem(id: IId) {
      try {
        const { data } = await UsersService.getDepartment(id);

        this.setItem(data);
      } catch (error) {
        return error;
      }
    },
    async updateOrCreate(body: IDepartmentBody) {
      try {
        await UsersService.updateOrCreateDepartment(body);
      } catch (error) {
        return error;
      }
    },
    async remove(id: IId) {
      try {
        await UsersService.deleteDepartment(id);
      } catch (error) {
        return error;
      }
    }
  })
});
